import { Box } from '@mui/material';
import React from 'react';
import CPUSection from '../components/CPUSection';
import ProductSlider3D from '../components/ProductSlider3D';
import TechnologiesSection from '../components/TechnologiesSection';

const AllProducts = () => {
  return (
    <Box component="main" sx={{ flexGrow: 1 }}>
      <CPUSection />
      <ProductSlider3D />
      <TechnologiesSection />
    </Box>
  );
};

export default AllProducts;


